module.exports = __webpack_public_path__ + "static/media/black-arrow-down.6e4ad863.svg";